import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";
import { fileHref } from "./common";

// Profile-photo moderation queue — approve/reject buttons stay next to each
// pending headshot so admins can clear the queue quickly; tapping the card
// itself opens the full user detail dialog for additional context.
export default function PhotosTab({ pendingPhotos, reviewPhoto, openUserDetail }) {
  return (
    <div className="space-y-4" data-testid="photos-tab">
      {pendingPhotos.length === 0 ? (
        <div className="bg-white/60 border border-sage/20 rounded-3xl p-10 text-center text-forest/60" data-testid="no-pending-photos">
          No profile photos waiting for review.
        </div>
      ) : (
        pendingPhotos.map((p) => (
          <div
            key={p.user_id}
            className="bg-white/80 border border-sage/20 rounded-3xl p-5 shadow-sm flex flex-wrap items-center gap-5 cursor-pointer hover:border-sage/50 hover:shadow-md transition"
            data-testid={`pending-photo-${p.user_id}`}
            onClick={() => openUserDetail(p)}
            role="button"
            tabIndex={0}
            onKeyDown={(ev) => { if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); openUserDetail(p); } }}
          >
            <img
              src={fileHref(p.pending_photo_path)}
              alt={`${p.name} profile photo submission`}
              className="w-24 h-24 rounded-full object-cover border border-sage/30 bg-white shrink-0"
              data-testid={`pending-photo-img-${p.user_id}`}
            />
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-bold text-forest" data-testid={`pending-photo-name-${p.user_id}`}>{p.name}</h3>
              <p className="text-xs text-forest/60">{p.email} · <span className="uppercase font-bold">{p.role}</span></p>
              {p.photo_submitted_at && (
                <p className="text-[11px] text-forest/40 mt-0.5">Submitted {new Date(p.photo_submitted_at).toLocaleString()}</p>
              )}
              <p className="text-[11px] text-sage-dark/70 font-semibold mt-1">Tap card to view full profile →</p>
            </div>
            <div className="flex gap-2 shrink-0" onClick={(ev) => ev.stopPropagation()}>
              <Button size="sm" variant="outline" onClick={() => reviewPhoto(p.user_id, "approve")} className="rounded-full border-sage text-sage-dark hover:bg-sage-light" data-testid={`approve-photo-${p.user_id}`}>
                <Check className="w-4 h-4 mr-1" /> Approve
              </Button>
              <Button size="sm" variant="ghost" onClick={() => reviewPhoto(p.user_id, "reject")} className="rounded-full text-terracotta-dark hover:bg-terracotta-light" data-testid={`reject-photo-${p.user_id}`}>
                <X className="w-4 h-4 mr-1" /> Reject
              </Button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
